import { FormattedMessage } from "react-intl";

const CommunitySupport = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.freeCommunitySupport.content.body"
                    defaultMessage="Find answers and support from other Atlassian users."
                />
            </p>
        </div>
    );
};

export default CommunitySupport;
